let n = 0, i = !1;
const c = function(t, e) {
  e.addEventListener("scroll", r);
  function r() {
    n = e.scrollLeft, i || (window.requestAnimationFrame(() => {
      t(n), i = !1;
    }), i = !0);
  }
  return function() {
    document.removeEventListener("scroll", r);
  };
};
class l extends HTMLElement {
  constructor() {
    super(), this.next = null, this.ticking = !1, this.ticking = !1, this.scrollTarget = this.getAttribute("scroll-target") || "", this.tracker = this.querySelector("span");
  }
  connectedCallback() {
    const t = document.getElementById(this.scrollTarget);
    if (!t) return;
    const e = this.getScrollOffset(t);
    this.renderTrackerPosition(e), c(() => {
      this.ticking || (this.next = () => setTimeout(() => {
        const s = this.getScrollOffset(t);
        this.renderTrackerPosition(s), this.ticking = !1;
      }, 20), this.ticking = !0);
      const r = this.getScrollOffset(t);
      this.renderTrackerPosition(r), this.next && this.next();
    }, t);
  }
  renderTrackerPosition(t) {
    if (!this.tracker) return;
    const e = this.tracker.offsetWidth, s = (this.offsetWidth - e) * t;
    this.tracker.style.transform = `translateX(${s}px)`;
  }
  getScrollOffset(t) {
    return t.scrollLeft / (t.scrollWidth - t.offsetWidth);
  }
}
window.customElements.get("scroll-tracker") || window.customElements.define(
  "scroll-tracker",
  l
);
export {
  l as ScrollTracker,
  c as rafScrollX
};
